import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faSquareArrowUpRight, faChevronRight, faChevronLeft, faCalendarAlt, faComment, faPlusCircle, faQuestionCircle} from "@fortawesome/free-solid-svg-icons"

const icons = {faSquareArrowUpRight, faChevronRight, faChevronLeft, faCalendarAlt, faComment, faPlusCircle, faQuestionCircle}

export default function Icon({name}) {
  return <FontAwesomeIcon icon={icons[name]} />
}
